import { createBox } from './basler-components.es867.js';
import { DOMVisualElement } from './basler-components.es863.js';
import { camelToDash } from './basler-components.es869.js';
import { buildSVGAttrs } from './basler-components.es870.js';
import { camelCaseAttributes } from './basler-components.es871.js';
import { isSVGTag } from './basler-components.es872.js';
import { renderSVG } from './basler-components.es873.js';
import { scrapeMotionValuesFromProps } from './basler-components.es874.js';
import { transformProps } from './basler-components.es783.js';
import { getDefaultValueType } from './basler-components.es812.js';

class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = createBox;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

export { SVGVisualElement };
